/**   
 * 巡更巡检接口统一管理
 */
import { axiosPost } from './http';

const prexfix = global.$config.api.apiUrl;
// const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk'
// const prexfix = 'http://biaozhunhua.zjht100.com'

// 巡检首页
export const getStatistical = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/cruisingcheck-api/cruisingcheck/statistical/findPage`, params)
};

// 巡检异常列表
export const getPatrolAbnormalList = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data 
  }
  return axiosPost(`/cruisingcheck-api/cruisingcheck/sPatrolTask/toDayTaskerrfindPage`, params)
};

// 巡检任务列表
export const getPatrolTaskList = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/cruisingcheck-api/cruisingcheck/sPatrolTask/findPage`, params)
};

// 巡检任务详情
export const getPatrolTaskDetail = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/cruisingcheck-api/cruisingcheck/sPatrolPointRecord/findPage`, params)
};

// 获取单位code
export const findOneTreeBySysCode = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`/manage-api/manage/perOrganization/findOneTreeBySysCode`, params)
}